import { render, staticRenderFns } from "./confirm-password-reset.vue?vue&type=template&id=a87e8dce&scoped=true&"
import script from "./confirm-password-reset.vue?vue&type=script&lang=ts&"
export * from "./confirm-password-reset.vue?vue&type=script&lang=ts&"
import style0 from "./confirm-password-reset.vue?vue&type=style&index=0&id=a87e8dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87e8dce",
  null
  
)

export default component.exports